import styled from "styled-components";

const MarginContainer = styled.div`
  margin-left: 0.75rem;
`;

export default MarginContainer;